import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #0f172a, #1e293b)',
      color: '#cbd5e1',
      textAlign: 'center',
      padding: '2.5rem',
      position: 'relative'
    }}>
      <p>© 2026 VTECH CODERS — AI-Powered Software Development & Training. All rights reserved.</p>
      <p style={{ marginTop: '0.5rem', fontSize: '0.9rem' }}>
        {/* <i className="fas fa-robot"></i> Built with React & AI magic */}
      </p>
    </footer>
  );
};

export default Footer;